import { logOut } from "../../../Redux/Auth/operations";
import { useAppDispatch } from "../../../Redux/store";
import useAuth from "../../../Redux/useAuth";
import { useLanguageContext } from "../../Languages/Langs/LanguageContext";
import {
  ButtonGreenLogout,
  ButtonLogoutContainer,
  ButtonRedLogout,
  LogoutContainer,
  LogoutModelContainer,
  TitleModelLogout,
} from "./LogoutStyles.styled";
import { useNavigate } from "react-router-dom";

interface SignInModelProps {
  onClose: () => void;
}

export const Logout: React.FC<SignInModelProps> = ({ onClose }) => {
  const { t } = useLanguageContext();
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const { user } = useAuth();

  const handleLogOut = () => {
    dispatch(logOut(user?.id || ""));
    navigation("/");
  };

  return (
    <>
      <LogoutModelContainer>
        <LogoutContainer>
          <TitleModelLogout>
            {t("privateTraslate.Models.LogoutTitle")}
          </TitleModelLogout>

          <ButtonLogoutContainer>
            <ButtonRedLogout onClick={handleLogOut} type="button">
              {t("privateTraslate.Models.LogoutTextYes")}
            </ButtonRedLogout>
            <ButtonGreenLogout onClick={onClose} type="button">
              {t("privateTraslate.Models.LogoutTextNo")}
            </ButtonGreenLogout>
          </ButtonLogoutContainer>
        </LogoutContainer>
      </LogoutModelContainer>
    </>
  );
};
